// src/components/BusinessCardFlow/components/CardList.js
import React from 'react';

export default function CardList({ cards, removeCard, processAll, extracting }) {
  const containerStyle = {
    textAlign: 'center',
    marginTop: '1rem',
    width: '100%',
    maxWidth: '400px'
  };
  const buttonStyle = {
    padding: '0.5rem 1.5rem',
    backgroundColor: '#2563eb',
    color: '#fff',
    border: 'none',
    borderRadius: '0.25rem',
    cursor: 'pointer',
    marginBottom: '1rem'
  };
  const listStyle = {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem'
  };
  const listItemStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#333',
    borderRadius: '0.25rem',
    padding: '0.5rem 1rem'
  };

  return (
    <div style={containerStyle}>
      <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>
        Captured Cards
      </h3>
      <p style={{ fontSize: '0.9rem', color: '#aaa', marginBottom: '1rem' }}>
        You have {cards.length} card(s) in the list.
      </p>

      {extracting ? (
        <p style={{ color: '#fff', marginBottom: '1rem', fontWeight: 'bold' }}>
          Extracting your cards, please wait...
        </p>
      ) : (
        <button onClick={processAll} style={buttonStyle}>
          Process All
        </button>
      )}

      <ul style={listStyle}>
        {cards.map((card, idx) => (
          <li key={idx} style={listItemStyle}>
            <span>Card #{idx + 1}</span>
            <button
              onClick={() => removeCard(idx)}
              style={{
                padding: '0.3rem 0.8rem',
                backgroundColor: '#dc2626',
                color: '#fff',
                border: 'none',
                borderRadius: '0.25rem',
                cursor: 'pointer'
              }}
            >
              Remove
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
